import { getUUID } from "@/utils";
import { get, merge } from "lodash-es";

// 包含了 drag 的 create 和 drag update
const dragCreateEdge = {
  buttonStyle: {
    width: 18,
    height: 18,
    cursor: "pointer",
  },

  dragPointStyle: {
    width: 18,
    height: 18,
    cursor: "move",
  },

  sourceId: null,
  edge: null,
  getEvents() {
    return {
      // "node:dragstart": "onNodeDropStart",
      "edge:mouseenter": "onEdgeMouseEnter",
      "edge:mouseleave": "onEdgeMouseLeave",

      "edge:dragstart": "onEdgeDragStart",
      "node:dragstart": "onNodeDropStart",
      "node:drop": "onNodeDropStart",
      drag: "updateEndPoint",
      dragend: "onDragEnd",
      afterupdateitem: "onEdgeUpdated",
    };
  },
  calcShouldBegin(ev) {
    const { target, item } = ev;
    const targetName = target.get("name") || "";
    const nodeType = get(item.getModel(), "nodeData.nodeType");
    const edges = item.getEdges();
    if (nodeType === "startNode" && edges.length) {
      return false;
    }
    if (
      ["source-hot-area", "anchor-point"].includes(targetName) &&
      !this.graph._addingEdgeByDrag &&
      !this.graph._addingEdgeByClick
    ) {
      return true;
    }
  },

  calcShouldBeginDragChange(ev) {
    const { target, item } = ev;
    const targetName = target.get("name") || "";
    console.log(targetName, target, item);
    if (
      targetName.startsWith("edgeButton:drag") &&
      !this.graph._addingEdgeByDrag &&
      !this.graph._addingEdgeByClick
    ) {
      return true;
    }
  },

  // 在创建或更新 edge  时候，不允许显示 button
  calcShouldShowHoverButton(ev) {
    if (!this.graph._addingEdgeByDrag && !this.graph._addingEdgeByClick) {
      return true;
    }
  },
  // 可以结束 edge
  calcShouldEnd({ item }, cEdge) {
    return true;
  },
  onDragEnd(ev) {
    if (this.edge) {
      this.drawEdgeEnd({ item: this.edge, x: ev.x, y: ev.y });
    }
  },
  drawEdgeEnd(ev) {
    if (this.key && !this.keydown) return;
    // 如果起点已经指定而终点未指定，则指定终点
    if (this.edge && this.calcShouldEnd(ev, this.edge, this.graph)) {
      const getEdgeConfig = this.getEdgeConfig;
      const node = ev.item;
      console.log(node, "============node");
      const model = node.getModel();
      let edgeConfig;
      if (getEdgeConfig) {
        edgeConfig = getEdgeConfig(
          {
            source: this.sourceId,
            target: model.id,
          },
          this,
          "createEnd",
        );
      } else {
        edgeConfig = this.edgeConfig;
      }

      const updateCfg = {
        ...edgeConfig,
        target: model.id,
        // DESC: 2024-07-16 source 点位永远在下部中间
        // getAnchorPoints 的 1 号坐标
        // 对于 start 节点，则是 getAnchorPoints 0 号位置坐标
        sourceAnchor: model.type === "start-node" ? 0 : 1,
        // DESC: 2024-07-16 target 点位，在上部中间
        //  getAnchorPoints 的 0 号坐标
        targetAnchor: 0,
      };

      // 更新边
      this.updateEdgeStack(updateCfg);
      this.createEnd();
    } else {
      // 无法创建 edge ，删除 edge， 结束创建流程
      this.cancelCreate();
      this.createEnd();
    }
  },
  onEdgeDragStart(ev) {
    // 触发 drag 箭头位置的修改 target 的动作。
    if (this.calcShouldBeginDragChange(ev)) {
      // 设置当前 edge
      this.edge = ev.item;
      this.startCreate();
      const sourceId = this.edge.getSource().get("id");
      // 将该边的 capture 设置为 false，这样可以拾取到后面的元素
      this.edge.getKeyShape().set("capture", false);
      this.sourceId = sourceId;
    }
  },
  // 有元素放在 node 上
  onNodeDropStart(ev) {
    if (this.key && !this.keydown) return;
    const node = ev.item;

    if (this.calcShouldBegin(ev)) {
      const graph = this.graph;
      const getEdgeConfig = this.getEdgeConfig;
      const model = node.getModel();

      // 获取自定义 edge 配置
      let edgeConfig;
      if (getEdgeConfig) {
        edgeConfig = getEdgeConfig(
          {
            source: model.id,
            target: model.id,
          },
          this,
          "createStart",
        );
      } else {
        edgeConfig = this.edgeConfig;
      }

      this.edge = graph.addItem(
        "edge",
        {
          ...edgeConfig,
          id: "node-" + getUUID(),
          source: model.id,
          target: model.id,
          // label: "选择条件  ▼",
        },
        false,
      );
      this.graph.setItemState(this.edge, "updating", true);
      this.sourceId = model.id;
      this.startCreate();
      // 将该边的 capture 设置为 false，这样可以拾取到后面的元素
      this.edge.getKeyShape().set("capture", false);
    } else {
      this.drawEdgeEnd(ev);
    }
  },
  updateEdgeStack(updateCfg) {
    const graph = this.graph;
    graph.updateItem(this.edge, updateCfg, false);
    if (graph.get("enabledStack")) {
      const addedModel = {
        ...this.edge.getModel(),
        itemType: "edge",
      };
      const after = {};
      after.edges = [addedModel];
      graph.pushStack("add", {
        before: {},
        after,
      });
    }
    // graph.emit("edge:afterUpdate", {
    //   item: this.edge,
    // });
  },
  cancelCreate() {
    if (this.edge && !this.edge.destroyed) {
      this.graph.removeItem(this.edge, false);
    }
  },
  createEnd() {
    if (this.edge) {
      // FIX: 可能存在其他地方被删除的情况，执行 stopCreate。此时会设置不了 state.
      if (!this.edge.destroyed) {
        this.edge.getKeyShape().set("capture", true);
        this.graph.setItemState(this.edge, "updating", false);
        this.onEdgeMouseLeave({ item: this.edge });
      }
      this.edge = null;
      this.stopDialog();
      const edgeGroup = this.graph.get("edgeGroup");
      if (edgeGroup) {
        edgeGroup.toBack();
        edgeGroup.set("capture", true);
        this.graph.paint();
      }
      this.graph.emit("xEdge:addOrUpdateEnd", { item: this.edge });
    }
    setTimeout(() => {
      this.graph._addingEdgeByDrag = false;
    }, 0);
  },
  startDialog() {
    this.graph._isInDialog = true;
  },
  stopDialog() {
    this.graph._isInDialog = false;
  },
  startCreate() {
    const edgeGroup = this.graph.get("edgeGroup");
    if (edgeGroup) {
      edgeGroup.toFront();
    }
    this.graph._addingEdgeByDrag = true;
  },
  // 边的起点已经确定，边的末端跟随鼠标移动
  updateEndPoint(ev) {
    if (this.key && !this.keydown) return;
    // 若此时 source 节点已经被移除，结束添加边
    if (!this.graph.findById(this.sourceId)) {
      this.createEnd();
      return;
    }

    if (this.edge && this.edge.destroyed) {
      this.cancelCreating({ item: this.edge });
    }

    const point = { x: ev.x, y: ev.y };

    if (this.edge) {
      // 更新边的终点为鼠标位置
      this.graph.updateItem(
        this.edge,
        {
          target: point,
        },
        false,
      );
    }
  },
  // 取消增加边，删除该边；
  cancelCreating(ev) {
    if (this.key && !this.keydown) return;
    const graph = this.graph;
    const currentEdge = ev.item;
    if (
      this.edge === currentEdge ||
      (ev.target && ev.target.isCanvas && ev.target.isCanvas())
    ) {
      if (this.edge && !this.edge.destroyed) graph.removeItem(this.edge, false);
      this.createEnd();
    }
  },
  // 由于位置在尾部， dragEnd 后，可能不会触发 onEdgeMouseLeave
  onEdgeMouseLeave(e) {
    const { item } = e;
    // item.toBack();
    this.setHighLightEdgeToBack(e);
    const group = item.getContainer();
    const edgeButtons = group.findAll((v) => {
      const vName = v.get("name");
      return vName.startsWith("edgeButton");
    });
    if (edgeButtons) {
      edgeButtons.forEach((button) => {
        if (!edgeButtons.destroyed) {
          group.removeChild(button);
          if (button.clear) {
            button.clear();
          }
        }
      });
    }
  },

  setHighLightEdgeToBack(e) {
    // const item = e.item;
    // item.toBack();
    // if (!this.graph._addingEdgeByClick && !this.graph._addingEdgeByDrag) {
    //   const edgeGroup = this.graph.get("edgeGroup");
    //   if (edgeGroup) {
    //     edgeGroup.toBack();
    //     this.graph.paint();
    //   }
    // }
  },
  setHighLightEdgeToFront(e) {
    // const item = e.item;
    // item.toFront();
    // const edgeGroup = this.graph.get("edgeGroup");
    // if (edgeGroup) {
    //   edgeGroup.toFront();
    //   this.graph.paint();
    // }
  },
  // 还是每次重新生成吧，这样位置是准确的
  onEdgeMouseEnter(e) {
    if (this.calcShouldShowHoverButton()) {
      const { item } = e;
      this.setHighLightEdgeToFront(e);

      const group = item.getContainer();
      const position = item.getKeyShape().getPoint(1);
      const hoverGroup = group.addGroup({
        name: "edgeButton:drag-group",
        capture: true,
        zIndex: 1000,
      });

      hoverGroup.addShape("rect", {
        attrs: {
          width: this.dragPointStyle.width,
          height: this.dragPointStyle.height,
          cursor: this.dragPointStyle.cursor,
          // fill: this.buttonBackground.base,
          fill: "transparent",
          lineWidth: 1,
          stroke: "#000000",
          x: position.x - this.dragPointStyle.width / 2,
          y: position.y - this.dragPointStyle.height / 2,
        },
        capture: true,
        draggable: true,
        zIndex: 200,
        name: `edgeButton:drag`,
      });

      // hoverGroup
      //   .addShape("image", {
      //     attrs: {
      //       opacity: 0,
      //       img: this.iconMaps["drag"],
      //       ...this.buttonStyle,
      //       x: position.x - 4,
      //       y: position.y - 4,
      //     },
      //     capture: true,
      //     draggable: true,
      //     zIndex: 250,
      //     name: `edgeButton:drag-icon`,
      //   })
      //   .animate(
      //     {
      //       opacity: 0.5,
      //     },
      //     150
      //   );
      hoverGroup.sort();
      group.sort();
    }
  },
  rerenderButton(e) {
    const item = e.item;
    const itemType = item?.getType() ?? "";
    if (itemType === "edge") {
      const group = item.getContainer();
      const hoverGroup = group.find((v) => {
        if (v.get("name") === "edgeButton:drag-group") {
          return true;
        }
      });
      if (hoverGroup) {
        const hoverGroupItems = hoverGroup.get("children");
        const position = item.getKeyShape().getPoint(1);
        hoverGroupItems.forEach((item) => {
          item.attr({
            x: position.x - this.buttonStyle.width / 2,
            y: position.y - this.buttonStyle.height / 2,
          });
        });
      }
    }
  },
  onEdgeUpdated(ev) {
    this.rerenderButton(ev);
  },
};

export const getDragCreateEdgeOpt = (opt) => {
  return merge({}, dragCreateEdge, opt);
};
